// androidVersion 自定义H5相关api
import request from '@/utils/request'
// 获取列表
export function getList() {
  return request({
    url: '/admin/versionAndroid/list',
    method: 'post'
  })
}
// 添加
export function addList(data) {
  return request({
    url: '/admin/versionAndroid/save',
    method: 'post',
    data: data
  })
}
// 编辑
export function editList(data) {
  return request({
    url: '/admin/versionAndroid/update',
    method: 'post',
    data: data
  })
}
// 删除
export function delList(data) {
  return request({
    url: '/admin/versionAndroid/delete',
    method: 'post',
    data: data
  })
}
// 获取列表
export function getList2() {
  return request({
    url: '/admin/driver/version/list',
    method: 'post'
  })
}
// 添加
export function addList2(data) {
  return request({
    url: '/admin/driver/version/save',
    method: 'post',
    data: data
  })
}
// 编辑
export function editList2(data) {
  return request({
    url: '/admin/driver/version/update',
    method: 'post',
    data: data
  })
}
// 删除
export function delList2(data) {
  return request({
    url: '/admin/driver/version/delete',
    method: 'post',
    data: data
  })
}